import React from 'react';
import { renderCheckboxList, columnWidth } from 'utils/async-list';
import { renderApplication } from 'modules/product';
import { Column } from 'react-virtualized';

export function list() {
  const rowClickedUrl = id => `/pco-manager/products/${id}`;
  const loadNextUrl = '/pco-manager/products/range.json';

  renderCheckboxList(rowClickedUrl, loadNextUrl, renderColumns);
}

export function create() {
  renderApplication(true);
}

export function edit(ctx) {
  renderApplication(true);
}

function renderColumns(width) {
  return [
    <Column
      key="name"
      dataKey="name"
      width={columnWidth(width, 16)}
      label="Nom du produit"
    />,
  ];
}



// WEBPACK FOOTER //
// ./src/modules/saas/products/index.js